import { Dialog } from '@mui/material'

type Props = {
  children: any
  isOpen: boolean
}

export default function Modal({ children, isOpen }: Props) {
  return (
    <Dialog maxWidth={false} open={isOpen}>
      <div className="dlg-child__Height">{children}</div>
    </Dialog>
  )
}
